import Component from './List';

export default Component;
